import { render } from "./IconElectraBrakes.vue?vue&type=template&id=42185686"
import script from "./IconElectraBrakes.vue?vue&type=script&lang=js"
export * from "./IconElectraBrakes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__